<script setup lang="tsx">
import { createDiscreteApi } from 'naive-ui';
import { useThemeStore } from '@/store/modules/theme';
import Header from './components/header.vue';

const themeStore = useThemeStore();

const { message, notification, dialog, loadingBar, modal } = createDiscreteApi(
  ['dialog', 'loadingBar', 'message', 'modal', 'notification'],
  {
    configProviderProps: {
      themeOverrides: themeStore.themeOverrides,
    },
  },
);
function registerNaiveTools() {
  window.$loadingBar = loadingBar;
  window.$dialog = dialog;
  window.$message = message;
  window.$notification = notification;
  window.$modal = modal;
}

registerNaiveTools();
</script>

<template>
  <div class="h-screen">
    <Header />
    <div class="fixed top-header left-0 right-0 bottom-0">
      <RouterView />
    </div>
  </div>
</template>
